import { useEffect } from "react";
import { updateIntercom } from "../utils/Utils.js";

interface IntercomEventAttributes {
  eventId?: number;
  playId?: number;
}

// Exposes the current event/play to Intercom so banners can target them.
// The real reset happens on the next full page load, via IntercomInitializer.ascx
// (every page exit here is a full navigation, so this hook's own unmount cleanup
// never actually runs in production).
export function useIntercomEventAttributes({ eventId, playId }: IntercomEventAttributes) {
  useEffect(() => {
    if (!eventId && !playId) return;
    updateIntercom({
      event_id: eventId ?? null,
      play_id: playId ?? null,
    });
    return () => {
      updateIntercom({ event_id: null, play_id: null });
    };
  }, [eventId, playId]);
}
